import React, { createContext, useContext, useState, useEffect } from "react";
import { MOBILE_SIZE } from "../shared/constants";

// Create the MediaQuery Context
const MediaQueryContext = createContext();

// MediaQuery Provider Component
export const MediaQueryProvider = ({ children }) => {
    const [isSmallScreen, setIsSmallScreen] = useState(
        window.matchMedia(`(max-width: ${MOBILE_SIZE}px)`).matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_SIZE}px)`);

        // Listener to update state on screen size change
        const handleMediaChange = () => setIsSmallScreen(mediaQuery.matches);

        mediaQuery.addEventListener("change", handleMediaChange);

        // Cleanup on component unmount
        return () => mediaQuery.removeEventListener("change", handleMediaChange);
    }, []);

    return (
        <MediaQueryContext.Provider value={{ isSmallScreen }}>
            {children}
        </MediaQueryContext.Provider>
    );
};

// Hook to access MediaQueryContext
export const useMediaQuery = () => useContext(MediaQueryContext);